var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#f9e595",
    transform: "rotate(-45 255.972 256.066)",
    "data-original": "#ffce00",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbd89b",
    d: "M510.106 287.292 368.178 145.364 124.859 407.456l103.017 103.017A258.91 258.91 0 0 0 256 512c130.792 0 238.674-98.084 254.106-224.708z",
    "data-original": "#ffa300",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M124.859 69.371v338.085H256.87l10-160.372-10-177.713z",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9edf5",
    d: "m368.178 145.364-47.054-29.126-28.939-46.867H256v338.085h112.178z",
    "data-original": "#e9edf5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdd2e1",
    d: "M292.185 145.364h75.993l-75.993-75.993z",
    "data-original": "#cdd2e1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3d2",
    d: "M153.732 159.924h84.626v30h-84.626zM153.732 207.563v30H256.87l6.778-15-6.778-15z",
    "data-original": "#bec3d2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9196aa",
    d: "M256 207.563h83.306v30H256z",
    "data-original": "#9196aa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3d2",
    d: "M153.732 255.204v30H256.87l3.989-15-3.989-15z",
    "data-original": "#bec3d2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9196aa",
    d: "M256 255.204h83.306v30H256z",
    "data-original": "#9196aa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3d2",
    d: "M153.732 302.844h99.746v30h-99.746z",
    "data-original": "#bec3d2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6c52",
    d: "M353.012 351.876c-36.736 0-66.624-29.887-66.624-66.623s29.888-66.624 66.624-66.624c.298 0 .592.019.89.022l10-16.525-10-13.486c-.297-.002-.592-.011-.89-.011-53.278 0-96.624 43.345-96.624 96.624s43.346 96.623 96.624 96.623c.297 0 .593-.009.89-.011l10-16.132-10-13.879c-.298.003-.592.022-.89.022z",
    "data-original": "#ff6c52",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6c52",
    d: "m283.976 333.076 21.212 21.213 48.713-48.713 10-22.323-10-20.103z",
    "data-original": "#ff6c52",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff432e",
    d: "M353.012 188.629v30a66.218 66.218 0 0 1 35.281 10.129L352.552 264.5v42.426l56.954-56.955a66.233 66.233 0 0 1 10.129 35.282c0 36.736-29.887 66.623-66.623 66.623v30c53.278 0 96.623-43.345 96.623-96.623s-43.345-96.624-96.623-96.624z",
    "data-original": "#ff432e",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/rejectIcon.e42eb7290415c8a5b89409b756cfa8af.svg";
export { ForwardRef as ReactComponent };